import { Shadow } from "../types";

export const getShadow = (shadow?: Shadow) => {

  switch (shadow) {
    case 'none':
      return 0
    case 'tiny':
      return 'var(--shadowBase)'
    case 'small':
      return 'var(--shadowBase2)'
    case 'medium':
      return 'var(--shadowBase3)'
    case 'large':
      return 'var(--shadowBase4)'
    default:
      return shadow
  }


}